import type { ImageServicePorts } from "../../model";

import type { Common } from "./ios";

import { EMPTY } from "~/shared/str";

function mapDtoToEntity({
  fileName,
  contentType,
  uploadedAt,
  ...rest
}: Common.OutSchema): ImageServicePorts.ProviderIos.Common.OutSchema {
  return {
    ...rest,
    fileName: fileName ?? EMPTY,
    contentType: contentType ?? EMPTY,
    uploadedAt: new Date(uploadedAt),
  };
}

export { mapDtoToEntity };
